import { BasicVertexEvent } from './BasicVertexEvent';
export class OpenVertexEvent extends BasicVertexEvent {
    constructor(obstacle, p) {
        super(obstacle, p);
    }
}
//# sourceMappingURL=OpenVertexEvent.js.map